<template>
  <div class="header" v-if="pageAllInit && showHeader">
    <div class="fw-height"></div>
    <div id="fw_header"></div>
    <!-- titlebar区域11 -->
    <div
      v-if="!isHide"
      :class="['header-bar', { isShowBar }, env.isBankabc ? 'bankABC' : '']"
      v-track="trackData.titlebarShow({ sku_id: skuId, share_content: isShareMoney ? 2 : 1, status: isShowBar })"
    >
      <!-- 占位，用于占用App的顶部信号栏高度 -->
      <div id="detailTabHeader" :class="[isShowBar ? 'bgWhite' : '']">
        <div :style="{ height: nativeHeight }"></div>
        <!-- titlebar内容 -->
        <div class="content">
          <div
            @click="goBack"
            :class="['icon', 'back', env.isAlipay ? 'back-hidden' : '']"
            v-track="
              trackData.titlebarClick({ sku_id: skuId, titlebar_content: 1, page_type: commonTrackData.page_type })
            "
            tabindex="0"
            role="button"
            aria-label="返回"
          >
            <v-icon class="icon-back" name="arrow-left-v3"></v-icon>
          </div>
          <!-- 推荐人 -->
          <template v-if="hasRecommendInfo">
            <recommend-by
              v-show="isShowRecommendBy"
              :class="recommendClass"
              :avatarPic="spuInfo.recommendUser.avatarPic"
              :userName="`${spuInfo.recommendUser.userName}为你推荐`"
            ></recommend-by>
          </template>
          <div
            v-if="isShowBar"
            class="navigator"
            v-track="
              trackData.titlebarShow({
                sku_id: skuId,
                share_content: isShareMoney ? 2 : 1,
                status: isShowBar,
                menu_list: ['商品', hasEvaluation && '评价', isShowIntro && '详情', hasRecommend && '推荐']
              })
            "
          >
            <div
              @click="tabPostion(modulesId.banner)"
              :class="['item', { active: activeId === modulesId.banner }]"
              v-track="
                trackData.titlebarClick({ sku_id: skuId, titlebar_content: 2, page_type: commonTrackData.page_type })
              "
            >
              商品
            </div>
            <div
              v-if="hasEvaluation"
              @click="tabPostion(modulesId.remark)"
              :class="['item', { active: activeId === modulesId.remark }]"
              v-track="
                trackData.titlebarClick({ sku_id: skuId, titlebar_content: 3, page_type: commonTrackData.page_type })
              "
            >
              评价
            </div>
            <div
              v-if="isShowIntro"
              @click="tabPostion(modulesId.introduction)"
              :class="['item', { active: activeId === modulesId.introduction }]"
              v-track="
                trackData.titlebarClick({ sku_id: skuId, titlebar_content: 4, page_type: commonTrackData.page_type })
              "
            >
              详情
            </div>
            <div
              v-if="hasRecommend"
              @click="tabPostion(modulesId.guesslike)"
              :class="['item', { active: activeId === modulesId.guesslike }]"
              v-track="
                trackData.titlebarClick({ sku_id: skuId, titlebar_content: 5, page_type: commonTrackData.page_type })
              "
            >
              推荐
            </div>
          </div>

          <div class="right">
            <div
              class="icon share"
              @click="doShare"
              v-track="
                trackData.titlebarClick({ sku_id: skuId, titlebar_content: 6, page_type: commonTrackData.page_type })
              "
              tabindex="0"
              role="button"
              aria-label="分享"
            >
              <v-icon class="i-share" name="icon-share-v2"></v-icon>
              <div v-if="isShareMoney" class="gift"></div>
            </div>
            <!-- <div
              class="icon menu"
              @click="toggleMenu"
              v-track="
                trackData.titlebarClick({ sku_id: skuId, titlebar_content: 7, page_type: commonTrackData.page_type })
              "
              tabindex="0"
              role="button"
              aria-label="更多"
            >
              <v-icon class="i-menu" name="icon-menu-v3"></v-icon>
            </div> -->
            <MenuList :isHeader="true" :menuIconTrackData="trackData.titlebarClick({ sku_id: skuId, titlebar_content: 7, page_type: commonTrackData.page_type })" @showHistory="showHistory"/>
          </div>
        </div>
      </div>
      <div id="secondTab" class="tab" v-if="isShowBar && isShowSecondBar">
        <div
          v-if="isShowIntro"
          @click="tabChange('tabContent1')"
          :class="'tabContent1' == tabActiveId ? 'active' : ''"
          class="item"
          tabindex="0"
          role="button"
        >
          商品介绍
        </div>
        <div class="vertical-line" v-if="isShowParameters || isShowBoxingInfo"></div>
        <div
          v-if="isShowParameters"
          @click="tabChange('tabContent2')"
          :class="'tabContent2' == tabActiveId ? 'active' : ''"
          class="item"
          tabindex="0"
          role="button"
        >
          规格参数
        </div>
        <div class="vertical-line" v-if="isShowBoxingInfo"></div>
        <div
          v-if="isShowBoxingInfo"
          @click="tabChange('tabContent3')"
          :class="'tabContent3' == tabActiveId ? 'active' : ''"
          class="item"
          tabindex="0"
          role="button"
        >
          包装清单
        </div>
      </div>
    </div>

    <!-- 菜单弹层 -->
    <!-- <div v-show="isShowMenu">
      <div
        @click="toggleMenu"
        @touchmove="isShowMenu = false"
        class="overlay-common-new"
        tabindex="0"
        aria-label="关闭菜单栏"
      ></div>
      <MenuList
        id="menuList"
        role="dialog"
        tabindex="-1"
        :isHeader="true"
        @showHistory="showHistory"
        :style="{ marginTop: nativeHeight }"
        v-statusBarHeight:[use]="'marginTop'"
      />
    </div> -->

    <!-- 分享海报 -->
    <v-os-popup
      :class="['share-popup', { 'group-share': isGroup, 'share-popup-bank': env.isBankabc }]"
      :show="isShowShare"
      :title="isShareMoney ? '推荐有礼' : '分享'"
      fullScreen
      @close="isShowShare = false"
      :footerShow="false"
      container="body"
    >
      <template>
        <a
          class="gift-tip"
          v-if="isShareMoney && textContent"
          :href="spuInfo.shareInfo.shareLinkUrl"
          v-track="{
            act: 'click',
            params: {
              cfrom: '00220|077',
              event_id: '00220|077',
              sku_id: skuId,
              share_type: 2,
              clickPos: 2,
              page_type: 1
            }
          }"
        >
          <span v-html="textContent"></span>
          <v-button size="small" type="frame" lineColor="#52391C">查看规则</v-button>
        </a>
        <div class="poster-img">
          <img :src="frontPoster" alt v-if="frontPoster" />
          <v-list-loading class="loading-container" v-else></v-list-loading>
        </div>
        <div class="save-tip" v-if="frontPoster">
          <template v-if="env.isBankabc || env.isVHome || env.isVivoHealth || env.isvChat">截图保存图片</template>
          <template v-else>长按图片可保存</template>
        </div>
      </template>
    </v-os-popup>

    <!-- 浏览记录 -->
    <Popup
      v-model="isShowHistory"
      get-container="body"
      position="right"
      :overlay="isShowHistory"
      overlay-class="history-overlay"
      class="history-popup"
      role="dialog"
      aria-modal="true"
      aria-hidden="false"
      aria-label="浏览记录弹窗"
    >
      <History />
    </Popup>
  </div>
</template>

<script>
import { Icon, Overlay, Popup } from '@vivo/shop-ui-h5'
import MenuList from '../menu-list'
import History from './components/history'
import RecommendBy from './components/recommend-by'
// 环境
import env from '@/utils/clientEnv'
import { scrollY } from '@/utils/scroll'
import config from 'config'
import { app, common } from '@/utils'
import { mapState, mapGetters, mapActions } from 'vuex'
import shop from '@/utils/shop'
// 导入请求函数
import { getPosterInfo, shareReward, sharePosterWx } from './api'
// 埋点数据
import trackData from './trackData'
// import html2canvas from 'html2canvas'

export default {
  name: 'Header',
  components: {
    Icon,
    Overlay,
    Popup,
    MenuList,
    History,
    RecommendBy
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo', 'pageAllInit']),
    ...mapGetters('detailv3', [
      'spuId',
      'skuId',
      'isPhone',
      // 'isAccessory',
      'isGroup',
      'isLottery',
      'hasRecommend',
      'hasEvaluation',
      'isYX',
      'commonTrackData',
      'discountType',
      'posterEnable',
      'productQuery',
      'shareQueryChannel',
      'isOperatorBuyType'
    ]),
    isHide() {
      return shop.hidenShopHeader()
    },
    // 判断是否存在二级标题
    hasSecondBar() {
      const flag = this.skuInfo?.boxingInfo || this.skuInfo?.parameters
      return flag && this.isShowIntro
    },
    // 判断是否需要显示二级标题
    isShowSecondBar() {
      if (this.hasSecondBar) {
        return (
          this.activeId === 'introduction' &&
          (this.tabsInScreen.tabContent1 || this.tabsInScreen.tabContent2 || this.tabsInScreen.tabContent3)
        )
      } else {
        return false
      }
    },
    // 是否显示规格参数
    isShowParameters() {
      return this.skuInfo?.parameters?.length
    },
    // 包装清单
    isShowBoxingInfo() {
      return this.skuInfo?.boxingInfo?.boxingListVos || this.skuInfo?.boxingInfo?.boxingImg
    },
    // 分享赚信息
    isShareMoney() {
      return this.spuInfo?.hasShareAward && this.shareMsg?.isLogin
    },
    // title
    textContent() {
      if (env.isOS4) {
        return this.spuInfo?.shareInfo?.textContent?.replace(/(\d+)/g, `<span style="font-weight: 400;">$1</span>`)
      } else {
        return this.spuInfo?.shareInfo?.textContent?.replace(
          /(\d+)/g,
          `<span style="-webkit-text-stroke: 0.3px;">$1</span>`
        )
      }
    },
    isShowIntro() {
      return this.skuInfo?.intro
    },
    isProd() {
      return process.env.NODE_ENV === 'production'
    },
    // 是否携带推荐人标识
    hasRecommendInfo() {
      return !!(
        (this.productQuery.vvshopReferee|| this.fromThirdShare) &&
        this.spuInfo?.recommendUser?.avatarPic &&
        this.spuInfo?.recommendUser?.userName
      )
    },
    // 是否显示推荐人标识
    isShowRecommendBy() {
      return !this.isShowBar && this.hasRecommendInfo
    },
    hasServiceTip() {
      return (this.spuInfo.commodityServiceTips || []).length > 0
    }
  },
  data() {
    return {
      env,
      // 模块ID
      modulesId: {
        banner: 'banner',
        remark: 'remark',
        introduction: 'introduction',
        guesslike: 'guess-like'
      },
      // 是否显示头部
      showHeader: (!(env.isVivoApp && !env.isDefaultHideTitle) && !env.isVHome) || env.isIOSVivoApp,
      // 当前生效的模块Id
      activeId: 'banner',
      // 切换titlebar显示方式
      isShowBar: false,
      isShowMenu: false,
      isShowShare: false,
      isShowHistory: false,
      // 官网App顶部高度
      appHeaderHeight: 0,
      canBtnSave: false,
      tabActiveId: 'tabContent1',
      //  判断三个tab对应的内容是否在视口中
      tabsInScreen: {
        tabContent1: false,
        tabContent2: false,
        tabContent3: false
      },
      // 分享卡片信息
      shareMsg: null,
      nativeHeight: '',
      // 判断是否为点击切换tab，如果为点击切换tab那么就不走observe
      isClickScroll: false,
      trackData,
      use: !env.isIOSVivoApp,
      recommendClass: 'first_show',
      frontPoster: null, //前端生成的海报图
      miniPoster: null, // 分享到小程序的海报图
      bgCanvasBase64: null, // 除二维码之外的背景海报图
      fromThirdShare: false,
      prevIsContract: false // 上次点击分享时，购买方式是否为移动合约机
    }
  },
  created() {
    this.getNativeHeight()
    // 绑定滚动事件，用于切换titlebar
    this.bindScrollEvent()
    // 注册Apptab签点击方法
    window.appUpdateTabStatus = this.updateTabStatus
    // 注册原生App方法
    this.initNative()
    // 全屏的话重新获取statusBarHeight
    window.onFullScreen = () => {
      this.getNativeHeight()
    }
  },
  mounted() {
    // 获取App Tab高度，用于Tab点击定位
    this.navBarHeight()
    const referrer = document.referrer
    if(referrer && referrer.indexOf('mshopact.vivo.com.cn') > -1 && referrer.indexOf('vvshopReferee=') > -1){
      this.fromThirdShare = true
    }
  },
  methods: {
    ...mapActions('detailv3', ['getSkuShareInfo']),
    getNativeHeight() {
      let self = this

      app.getTitleBarHeight({
        type: 'statusBarHeight',
        success: res => {
          // + 10  为了多空一些距离，避免太靠近
          if (env.isIOSVivoApp) {
            self.nativeHeight = `${res}px`
          } else {
            self.nativeHeight =
              env.isPadVivoApp || env.isFoldableApp
                ? ((((res + 24) * 400) / (100 * 720)) * 150) / 100 + 'rem'
                : ((((res + 24) * window.screen.width) / (100 * 720)) * 150) / 100 + 'rem'
          }
        }
      })
    },
    /**
     * 注册原生App方法，用于App调用
     */
    initNative() {
      // 注册APP方法
      window.appPosterInfo = this.appPosterInfo
      this.shareByAppCallBack()
    },

    /**
     * 接入官网悬浮条
     */
    async includeDown() {
      // 判断跳转商详页是否需要打开官网app
      let deepLink = shop.allowShopDeeplink()
      // 接入官网悬浮下载
      let target = shop.formatVivoUrl(location.href)
      if (target.indexOf('?') < 0) {
        target = target + '?from_deeplink=true'
      } else {
        const temp = target.split('?')
        temp[1] = 'from_deeplink=true&' + temp[1]
        target = temp.join('?')
      }
      target = 'space://vivo.com/web?&uri=' + target
      const res = await env.isWeChatApp()
      !env.isVivoApp &&
        !res &&
        shop.includeFW({ needDeeplink: `${deepLink ? '1' : '0'}`, deeplinkUrl: encodeURIComponent(target) })
    },
    shareClose() {
      this.isShowShare = false
    },
    /**
     * 初始化生成海报图背景 - 仅在前端支持生成海报图的前提下处理
     *
     */
    initHtmlCanvas() {
      // 延迟支持
      if (this.posterEnable && !this.bgCanvasBase64) {
        if (env.isVivoApp) {
          // 客户端内
          return this.hasServiceTip ? this.posterDoublePromise() : this.posterSimplePromise()
        } else {
          // H5
          return this.posterSimplePromise()
        }
      }
      return new Promise(resolve => {
        resolve()
      })
    },
    /**
     * 点击分享
     */
    doShare() {
      console.log(new Date().getTime())
      // 如果上次点击分享时购买方式是移动合约机 但本次不是；或者上次点击分享时购买方式不是移动合约机 但本次是
      if (this.prevIsContract !== this.isOperatorBuyType) {
        this.frontPoster = null
        this.prevIsContract = this.isOperatorBuyType
      }
      // 支持前端生成海报图
      if (this.posterEnable) {
        if (env.isVivoApp) {
          // 客户端内
          this.showAppSharePop()
          if (!this.frontPoster) {
            if (this.bgCanvasBase64) {
              this.compositionCanvas()
              return
            }
            // 延迟避免iframe与webveiw启动冲突
            setTimeout(() => {
              this.compositionCanvas()
            }, 100)
          }
          return
        } else {
          // H5
          this.showH5SharePop()
          if (!this.frontPoster) {
            this.compositionCanvas()
          }
          return
        }
      }
      // 降级逻辑 IOS客户端、Android客户低版本
      if (env.isDefaultHideTitle || env.isIOSVivoApp) {
        this.showAppSharePop()
      } else {
        this.shareImage()
      }
    },
    queryQrcodePromise() {
      return new Promise((resolve, reject) => {
        // 改为请求二维码接口 耗时600ms
        const time1 = new Date().getTime()
        let param = {
          skuId: this.skuId,
          channel: this.shareQueryChannel
        }
        // 合约机增加buyType入参
        if (this.isOperatorBuyType) {
          param.buyType = 3
        }
        sharePosterWx(param)
          .then(res => {
            console.log('请求接口耗时')
            console.log(new Date().getTime() - time1)
            const qrcode = `data:image/png;base64,${res}`
            const image = new Image()
            image.setAttribute('crossOrigin', 'anonymous')
            image.src = qrcode
            image.onload = function () {
              console.log('图片拉取耗时')
              console.log(new Date().getTime() - time1)
              resolve(image)
            }
            image.onerror = function () {
              reject('小程序码获取失败1')
            }
          })
          .catch(e => {
            reject('小程序码获取失败2')
          })
      })
    },
    /**
     * 叠加请求获取二维码，合并模版canvas和二维码图片
     * 前提是背景海报 & 二维码都加载完成才可以执行合并操作
     */
    async compositionCanvas() {
      const self = this
      const t0 = new Date().getTime()
      console.log(t0)
      let qrcode = null
      try {
        const res = await Promise.all([this.queryQrcodePromise(), this.initHtmlCanvas()])
        qrcode = res[0] || null
      } catch (e) {
        this.setDefaultPoster()
        return
      }
      const image = new Image()
      image.src = this.bgCanvasBase64
      const imgPromise = new Promise(resolve => {
        image.onload = function () {
          console.log('bgCanvasBase64 load')
          console.log(new Date().getTime() - t0)
          resolve()
        }
      })
      imgPromise
        .then(res => {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height

          var ctx = canvas.getContext('2d')

          ctx.drawImage(image, 0, 0)
          ctx.drawImage(qrcode, 789, 1368, 221, 221)

          // 将canvas对象转换为base64位编码
          self.frontPoster = canvas.toDataURL('image/jpeg', 1)
          console.log('最终耗时')
          console.log(new Date().getTime() - t0)
          console.log(new Date().getTime())
          self.setShareConfig()
        })
        .catch(e => {
          self.setDefaultPoster()
        })
    },

    /**
     * 生成大海报图和小程序海报图
     * 1、进入页面 - 直接绘制两张海报图【小程序海报图】、【除二维码之外的大海报图】- 点击分享
     * 2、进入页面 正在绘制两张海报图 - 点击分享 - 等待绘制完成&叠加背景+二维码海报图导出
     * 3、进入页面 - 直接点击分享 - 请求接口 & 绘制两张海报图 & 叠加背景+二维码海报图导出
     * 分为3部分 绘制两张无需海报图的背景图【原逻辑posterDoublePromise/posterSimplePromise】 请求二维码接口 叠加背景+二维码导出
     */
    async posterDoublePromise() {
      // 生成海报图依赖服务端返回小程序二维码
      // if (!this.shareMsg?.qrcodeUrl) {
      //   await this.getShareContent()
      // }
      return new Promise((resolve, reject) => {
        if (this.bgCanvasBase64) resolve()
        const canvasContent = document.querySelector('#double_canvas')
        const shareContent = document.querySelector('#J_share_poster')
        const miniContent = document.querySelector('#J_mini_poster')
        var width = canvasContent.offsetWidth
        var scale = 1080 / width
        html2canvas(
          canvasContent,
          {
            useCORS: true, // 【重要】开启跨域配置
            removeContainer: this.isProd,
            scale: scale,
            width: shareContent?.offsetWidth,
            height: shareContent?.offsetHeight,
            selector: 'share-container',
            logging: !this.isProd,
            ignoreElements: child => {
              const position = child.compareDocumentPosition(canvasContent)
              if (position >= 8 || position >= 16 || position == 0) {
                return false
              }
              if (child.tagName == 'HEAD' || (child.tagName === 'STYLE' && child.hasAttribute('data-canvas-ignore'))) {
                return false
              }
              return true
            },
            allowTaint: true // 允许跨域图片
          },
          {
            useCORS: true, // 【重要】开启跨域配置
            removeContainer: this.isProd,
            scale: scale,
            logging: !this.isProd,
            width: miniContent.offsetWidth,
            height: miniContent.offsetHeight,
            selector: 'mini-container',
            ignoreElements: child => {
              const position = child.compareDocumentPosition(canvasContent)
              if (position >= 8 || position >= 16 || position == 0) {
                return false
              }
              if (child.tagName == 'HEAD' || (child.tagName === 'STYLE' && child.hasAttribute('data-canvas-ignore'))) {
                return false
              }
              return true
            },
            allowTaint: true // 允许跨域图片
          }
        )
          .then(canvasList => {
            const canvas0 = canvasList[0]
            const canvas1 = canvasList[1]
            this.bgCanvasBase64 = canvas0.toDataURL('image/jpeg', 1)
            if (canvas1) {
              this.miniPoster = canvas1.toDataURL('image/jpeg', 1)
            }
            resolve()
          })
          .catch(e => {
            reject(e)
            console.log(e)
          })
      })
    },
    /**
     * 单独生成海报图
     */
    async posterSimplePromise() {
      // 生成海报图依赖服务端返回小程序二维码
      // if (!this.shareMsg?.qrcodeUrl) {
      //   await this.getShareContent()
      // }
      return new Promise((resolve, reject) => {
        if (this.bgCanvasBase64) resolve()
        const shareContent = document.querySelector('#J_share_poster')
        var width = shareContent.offsetWidth
        var height = shareContent.offsetHeight
        var scale = 1080 / width
        html2canvas(shareContent, {
          useCORS: true, // 【重要】开启跨域配置
          removeContainer: this.isProd,
          scale: scale,
          width: width,
          height: height,
          logging: !this.isProd,
          ignoreElements: child => {
            const position = child.compareDocumentPosition(shareContent)
            if (position >= 8 || position >= 16 || position == 0) {
              return false
            }
            if (child.tagName == 'HEAD' || (child.tagName === 'STYLE' && child.hasAttribute('data-canvas-ignore'))) {
              return false
            }
            return true
          },
          allowTaint: true // 允许跨域图片
        })
          .then(canvas => {
            const path = (this.bgCanvasBase64 = canvas.toDataURL('image/jpeg', 1))
            // const path = (this.frontPoster = canvas.toDataURL('image/jpeg', 1))
            this.miniPoster = this.skuInfo?.imageInfos[0].bigPic
            resolve(path)
          })
          .catch(e => {
            reject(e)
            console.log(e)
          })
      })
    },
    // /**
    //  * 客户端内生成海报图 - 两张
    //  */
    // generatePosterApp() {
    //   return this.hasServiceTip ? this.posterDoublePromise() : this.posterSimplePromise()
    // },
    // /**
    //  *  H5生成海报图 - 一张
    //  */
    // generatePosterH5() {
    //   return this.posterSimplePromise()
    // },
    /**
     * 设置生成海报图失败的降级逻辑，走原服务端接口能力，或直接用商品主图
     */
    setDefaultPoster() {
      this.shareImage(
        data => {
          this.frontPoster = this.frontPoster || data.commodityPosterUrl
          this.miniPoster = this.miniPoster || this.skuInfo?.imageInfos[0].bigPic
          this.setShareConfig()
        },
        e => {
          this.frontPoster = this.frontPoster || this.skuInfo?.imageInfos[0].bigPic
          this.miniPoster = this.miniPoster || this.skuInfo?.imageInfos[0].bigPic
          this.setShareConfig()
        }
      )
    },
    /**
     * APP直接设置文本数据，调用分享弹层展示Loading
     */
    showAppSharePop() {
      this.setShareConfig()
      setTimeout(() => {
        window.vivospace.doshare()
      }, 20)
    },
    /**
     * H5展示海报图弹层
     */
    showH5SharePop() {
      this.isShowShare = true
      this.isShowMenu = false
    },
    /**
     * 分享海报, successCB、errorCB用于app海报分享回调
     */
    async shareImage(successCB, errorCB) {
      let self = this

      let param = {
        spuId: self.spuId,
        skuId: self.skuId,
        // 1：普通分享 2：分享赚分享 3：常规团 4:一分团
        channel: self.isLottery ? 4 : self.isGroup ? 3 : self.isShareMoney ? 2 : 1,
        isNoShare: 1,
        promotionId: this.skuInfo.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.promotionId || ''
      }
      // 合约机增加buyType入参
      if (this.isOperatorBuyType) {
        param.buyType = 3
      }
      getPosterInfo(param)
        .then(data => {
          if (successCB) {
            successCB(data)
          } else {
            this.frontPoster = data.commodityPosterUrl
            this.isShowShare = true
            this.isShowMenu = false
          }
        })
        .catch(e => {
          if (errorCB) {
            errorCB(e)
          } else {
            self.$toast(e && e.msg)
          }
        })
    },

    /**
     * 分享海报，原生App调用
     */
    appPosterInfo() {
      let self = this
      this.shareImage(
        data => {
          try {
            // 注销之前绑定的回调，重新注册新回调，否则会有两个回调
            window.vivospace && window.vivospace.setshareCallBack && window.vivospace.setshareCallBack(null)
          } catch (e) {}
          app.sharePoster({
            imageUrl: data.commodityPosterUrl,
            shareTitle: '分享海报给好友',
            finishCallBack: 'shareImageFinish'
          })
          // 该方法只会调用一次
          window.shareImageFinish = function () {
            self.doShareCallback()
          }
        },
        e => {
          self.$toast(e && e.msg)
        }
      )
    },

    /**
     * 分享成功回调
     */
    shareByAppCallBack() {
      let self = this
      if (window.vivospace && typeof window.vivospace.setshareCallBack === 'function') {
        window.shareEndCallBack = function (content) {
          self.doShareCallback()
        }
        window.vivospace.setshareCallBack('shareEndCallBack')
      }
    },

    /**
     * 分享海报， 送积分、经验
     */
    doShareCallback() {
      let self = this
      shareReward({})
        .then(data => {
          // 获取提示信息
          let message = common.shareRewardTip('分享', data)
          if (message) {
            self.$toast({
              type: 'html',
              message: message
            })
          }
        })
        .catch(() => {})
    },

    /**
     * 获取分享信息： 原逻辑仅在支持推荐有礼的活动下调用分享，现改为所有场景调用。
     * 原接口返回null的情况仅与登录态有关，现接口新增isLogin字段控制分享有礼和普通分享的区分配置逻辑
     */
    async getShareContent() {
      const shareInfo = await this.getSkuShareInfo()
      this.shareMsg = { ...shareInfo } || null // 避免拷贝后，修改qrcodeUrl影响存储数据
      setTimeout(() => {
        this.setShareConfig()
      }, 500)
    },

    /**
     * 设置分享信息，用于App分享、微信分享
     */
    setShareConfig() {
      const images = this.shareMsg?.image ? [this.shareMsg?.image] : this.skuInfo?.imageInfos
      const miniImg = ((images || [])[0] || {}).bigPic || ''
      let shareParams = {
        desc: this.skuInfo?.commoditySkuBaseInfo?.brief,
        link:
          this.shareMsg?.shortUrl ||
          (this.shareMsg?.h5Url
            ? `${this.shareMsg.h5Url}`
            : `${config.path.shopUrl}/product/${this.spuId}?skuId=${this.skuId}&isNoShare=1`),
        miniPath: this.shareMsg?.miniAppUrl
          ? `pages/product/index?${this.shareMsg.miniAppUrl}`
          : `pages/product/index?spuId=${this.spuId}&skuId=${this.skuId}&isNoShare=1`,
        images: images,
        sharePosterToSpaceFlag: this.posterEnable ? -1 : 0, // 设置分享朋友圈为海报大图分享
        downloadChannelShow: this.posterEnable ? -1 : 0, // 控制保存图片按钮是否展示
        weiboChannelShow: -1, // -1不展示微博分享渠道, 0展示微博分享渠道
        posterLargeImg: this.frontPoster || '', // 海报图&小程序封面图配置
        shareFrom: 'sku',
        shareSKUId: this.skuId
      }
      let title = ''
      if (this.isGroup) {
        shareParams.wxfriend = null
        // 拼团分享信息定制
        let commodityGroupon = this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon
        if (commodityGroupon.shareTitle) {
          shareParams.title = commodityGroupon.shareTitle
        }
        if (commodityGroupon.shareDesc) {
          shareParams.desc = commodityGroupon.shareDesc
        }
      }
      // 推荐有礼（原分享赚-已登录状态下）
      else if (this.isShareMoney) {
        title = `向你推荐【${this.skuInfo?.commoditySkuBaseInfo?.skuName}】`
        shareParams = {
          ...shareParams,
          ...{
            title: title + '立即查看>',
            wxfriend: {
              title: title.replace(/\+/gi, ' + '),
              miniImg: this.miniPoster || miniImg,
              miniPath: shareParams.miniPath
            },
            copy: {
              title: title + '立即查看'
            }
          }
        }
        // 分享弹层上方&折叠屏pad利益条相关配置
        shareParams.dialogAdvImg = this.spuInfo?.shareInfo?.shareIcon // 客户端旧版本利益条图片
        shareParams.dialogAdvImgJump = shareParams.dialogCustomContentJump = this.spuInfo?.shareInfo?.shareLinkUrl
        shareParams.dialogCustomTitle = this.spuInfo?.shareInfo?.shareTitle
        shareParams.dialogCustomContent = this.spuInfo?.shareInfo?.textContent
        shareParams.dialogAdvIcon = this.spuInfo?.shareInfo?.actPic // 悬浮活动图片
        shareParams.dialogAdvTextColor = this.spuInfo?.shareInfo?.textColor // 文案颜色
        shareParams.dialogAdvBg = this.spuInfo?.shareInfo?.benefitColor // 利益条底色
      } else {
        // 普通分享
        title = `${this.skuInfo?.commoditySkuBaseInfo?.skuName}`
        shareParams = {
          ...shareParams,
          ...{
            title: `【${title}】立即查看>`,
            wxfriend: {
              title: title.replace(/\+/gi, ' + '),
              miniImg: this.miniPoster || miniImg,
              miniPath: shareParams.miniPath
            },
            copy: {
              title: `【${title}】立即查看`
            }
          }
        }
      }

      // app分享
      app.setShareConfig(shareParams)
    },

    /**
     * 获取app顶部导航高度
     */
    navBarHeight() {
      if (this.env.isDefaultHideTitle) {
        return
      }
      let self = this
      // 官网app状态栏高度px
      app.getTitleBarHeight({
        type: 'navBarHeight',
        success: function (val) {
          self.appHeaderHeight = ((val * window.screen.width) / (100 * 720)) * 108
        }
      })
    },

    /**
     * 绑定滚动事件，用于切换titlebar
     */
    bindScrollEvent() {
      let self = this
      // 不使用节流，是为了快速切换titlebar，提升体验
      window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        self.isShowBar = scrollTop > 20
      })
    },

    /**
     * 监听一级标题元素是否进入视口
     */
    observe(id) {
      let self = this
      let idToIndex = {
        [self.modulesId.banner]: 0,
        [self.modulesId.remark]: 1,
        [self.modulesId.introduction]: 2,
        [self.modulesId.guesslike]: 3,
        [self.modulesId.service]: 3
      }
      const IO = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (self.isClickScroll) {
            return
          }
          // 元素进入视口，触发埋点
          if (entry.isIntersecting) {
            self.activeId = entry.target.id
            app.setTitleBarIndex({
              index: idToIndex[self.activeId],
              error: () => {}
            })
          } else {
            // 防止当评价详情都在视口中的情况，会出现混乱
            if (self.activeId === self.modulesId.remark && entry.target.id === self.modulesId.remark) {
              self.activeId = self.modulesId.introduction
              app.setTitleBarIndex({
                index: idToIndex[self.activeId],
                error: () => {}
              })
            }
          }
        })
      })
      if (id) {
        this.$nextTick(() => {
          document.getElementById(id) && IO.observe(document.getElementById(id))
        })
      } else {
        for (let key in this.modulesId) {
          const tempId = this.modulesId[key]
          document.getElementById(tempId) && IO.observe(document.getElementById(tempId))
        }
      }
    },

    /**
     * 监听二级标题元素是否进入视口
     */
    observeSecond() {
      let tabs = ['tabContent1', 'tabContent2', 'tabContent3']
      let self = this
      const IO = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (self.isClickScroll) {
            return
          }
          // 元素进入视口，触发埋点
          if (entry.isIntersecting) {
            self.tabActiveId = entry.target.id
            self.activeId = 'introduction'
          }
          self.tabsInScreen[entry.target.id] = entry.isIntersecting
        })
      })
      tabs.forEach(id => {
        document.getElementById(id) && IO.observe(document.getElementById(id))
      })
    },

    /**
     * 用于App页签切换
     */
    updateTabStatus(index) {
      const appTabs = [
        this.modulesId.banner,
        this.modulesId.remark,
        this.modulesId.introduction,
        this.modulesId.guesslike
      ]
      appTabs[index] && this.tabPostion(appTabs[index])
    },

    /**
     *  一级tab切换
     */
    tabPostion(id) {
      // 设置当前选中的Tab
      this.activeId = id
      this.scrollToModule(id)
    },

    /**
     *  滚动到具体模块
     */
    scrollToModule(id, isSecond) {
      let self = this
      self.isClickScroll = true
      let deepLinkHeight =
        (document.getElementById('fw_header') && document.getElementById('fw_header').offsetHeight) || 0
      let bankABCHeight =
        (document.querySelector('.abc-header') && document.querySelector('.abc-header').offsetHeight) || 0
      let headHeight =
        (document.getElementById('detailTabHeader') && document.getElementById('detailTabHeader').offsetHeight) || 0
      // 当点击的是详情时，存在二级tab，设置二级tab高度
      let secondBarHeight = (id === self.modulesId.introduction && self.hasSecondBar) || isSecond ? 40 : 0
      if (id === self.modulesId.introduction && self.hasSecondBar) {
        self.tabsInScreen.tabContent1 = true
      }
      if (id !== self.modulesId.introduction && !isSecond) {
        self.tabsInScreen.tabContent1 = false
        self.tabsInScreen.tabContent2 = false
        self.tabsInScreen.tabContent3 = false
      }
      let top =
        document.getElementById(id).offsetTop -
        (self.appHeaderHeight + headHeight + bankABCHeight + deepLinkHeight + secondBarHeight)
      scrollY(
        top,
        {
          duration: id === self.modulesId.guesslike ? 0 : 0
        },
        () => {
          setTimeout(() => {
            self.isClickScroll = false
          }, 100)
        }
      )
    },

    /**
     * 显示隐藏汉堡菜单
     */
    // toggleMenu() {
    //   this.isShowMenu = !this.isShowMenu
    //   // if (this.isShowMenu) {
    //   this.$nextTick(() => {
    //     if (this.isShowMenu) {
    //       document.getElementById('menuList').focus()
    //     }
    //   })
    //   // }

    //   // 禁止屏幕滑动
    //   // if (this.isShowMenu) {
    //   //   document.body.classList.add('v-overflow-hidden')
    //   // }
    //   // else {
    //   //   document.body.classList.remove('v-overflow-hidden')
    //   // }
    // },
    /**
     * 菜单展开时，蒙层滚动穿透禁用
     */
    // preventTouchMove(event){
    //   event.preventDefault()
    //   event.stopPropagation()
    //   return false
    // },

    /**
     * 显示浏览记录
     */
    showHistory() {
      // this.toggleMenu()
      this.isShowHistory = true
    },

    /**
     * 返回上一页
     */
    goBack() {
      if (env.isVivoApp) {
        try {
          app.appGoBack()
        } catch (e) {
          common.goBack()
        }
      } else {
        common.goBack()
      }
    },

    /**
     * 切换二级tab签
     */
    tabChange(id) {
      this.tabActiveId = id
      this.scrollToModule(id, true)
    },

    /**
     * 设置Apptab内容
     */
    setAppTab() {
      let arr = ['商品', '评价', '详情']
      if (this.hasRecommend) {
        arr.push('推荐')
      }
      // 设置官网APP头
      app.setDetailPageTitlebar(arr)
      // 是否显示评价
      app.isShowTitlebarComment({ isShow: this.hasEvaluation })
    },

    /**
     * 推荐标识曝光
     */
    recommendUserTrack() {
      this.$track({
        cfrom: '081|076|02|077',
        event_id: '081|076|02|077',
        recommend_openid: this.spuInfo.recommendUser.openId,
        skuid: this.skuId
      })
    }
  },
  watch: {
    isShowHistory(val) {
      if (val) {
        this.$nextTick(() => {
          document.getElementById('app').setAttribute('aria-hidden', 'true')
          document.getElementById('historyTitle')?.focus()
        })
      } else {
        document.getElementById('app').removeAttribute('aria-hidden')
      }
    },
    isShowBar(val) {
      if (val) {
        app.setStatusBarColor('black')
      } else {
        const videoStart = document.getElementById('video-start')
        const bannner = document.getElementById('banner')
        const bannerCurrent = bannner.dataset.current
        if (!videoStart && bannerCurrent === 0) {
          app.setStatusBarColor('white')
        }
      }
    },
    isShowRecommendBy(val){
      if(!val && this.recommendClass) {
        this.recommendClass = ''
      }
    },
    // 评价是动态获取，获取完以后需要添加监听
    hasEvaluation(val) {
      val && this.observe(this.modulesId.remark)
      this.setAppTab()
    },
    // 推荐是动态获取，获取完以后需要添加监听
    hasRecommend(val) {
      val && this.observe(this.modulesId.guesslike)
      this.setAppTab()
    },
    // 监听spu是否变化
    spuInfo() {
      if (this.spuInfo?.recommendUser?.avatarPic && this.spuInfo?.recommendUser?.userName) {
        this.recommendUserTrack()
      }
    },
    // 监听sku是否变化
    skuInfo() {
      // 二级tab签监听视口
      this.$nextTick(() => {
        this.observeSecond()
      })
    },
    // 监听skuId变化，变化后，重置分享信息
    skuId: {
      handler: function (val) {
        if (val) {
          this.frontPoster = ''
          this.miniPoster = ''
          this.bgCanvasBase64 = ''
          // 切换sku获取分享短链
          this.getShareContent()

          if (this.spuInfo?.recommendUser?.avatarPic && this.spuInfo?.recommendUser?.userName) {
            this.recommendUserTrack()
          }
          // 初始化绘制画布

          setTimeout(() => {
            if (window.html2canvas) {
              this.initHtmlCanvas()
            }
          }, 500)
        }
      },
      immediate: true
    },
    // 监听购买方式由”立即购买“或”以旧换新“切换到”移动用户特惠“，或者由“移动用户特惠”切换到“立即购买”或“以旧换新”
    isOperatorBuyType() {
      this.frontPoster = ''
      this.miniPoster = ''
      this.bgCanvasBase64 = ''
      // 切换sku获取分享短链, 购买方式如果切换到移动合约机，不读取缓存、重新获取分享信息且
      this.getShareContent()

      if (this.spuInfo?.recommendUser?.avatarPic && this.spuInfo?.recommendUser?.userName) {
        this.recommendUserTrack()
      }
      // 初始化绘制画布

      setTimeout(() => {
        if (window.html2canvas) {
          this.initHtmlCanvas()
        }
      }, 500)
    },
    isShowShare(val) {
      if (val) {
        this.$track({
          cfrom: '00219|077',
          event_id: '00219|077',
          sku_id: this.skuId,
          share_type: this.isShareMoney ? 2 : 1,
          popup_type: 2,
          page_type: 1 // 分享页面类型(1:商详页、2:商城活动页)
        })
      }
    },
    // isShareMoney(val) {
    //   if (val) {
    //     this.getShareContent()
    //   }
    // },
    pageAllInit(val) {
      if (val) {
        this.setAppTab()
        // 接入官网悬浮条
        this.includeDown()
        // 监听页面元素
        this.$nextTick(() => {
          // 监听视口
          this.observe()
          // 二级tab签监听视口
          this.observeSecond()
        })
      }
    }
  }
}
</script>

<style lang="scss">
// deeplink 下载样式适配
.vp-header-show-app {
  .overlay-common-new {
    top: 60PX !important;
  }
  .fw-height {
    height: 60PX;
  }
  .header-bar {
    top: 60PX !important;
  }
}
</style>

<style lang="scss" scoped src="./index.scss"></style>
